import type { FC } from 'react';

import { ModalLoading } from 'Features/SellerCommunications/components/ModalLoading';
import { T } from 'Features/SellerCommunications/utils/translate';

export const EnquirySelectionLoading: FC = () => (
	<ModalLoading
		description={T.translate('enquiryList.loadingDescription')}
		title={T.translate('enquiryList.loadingTitle')}
	/>
);
